/**
 * https://tomchentw.github.io/react-google-maps/
 */
import React, { Component } from 'react';
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from 'react-google-maps';
import { MarkerClusterer } from "react-google-maps/lib/components/addons/MarkerClusterer";

class googleMapComponent extends Component {
    constructor(props){
        super(props)
        this.state = {
			map: null
		}
        // this.mapMoved = this.mapMoved.bind(this);
        // this.mapLoaded = this.mapLoaded.bind(this);
        // this.handleMarkerClick = this.handleMarkerClick.bind(this);
        // this.handleMarkerClose = this.handleMarkerClose.bind(this);
	}

    mapMoved(){
        console.log('mapMoved: ' + JSON.stringify(this.state.map.getCenter()))
    }

    mapLoaded(map){
        if(this.state.map !==null)
            return

        this.setState({
            map:map
        })
        console.log('mapLoaded: ' + JSON.stringify(map.getCenter()))
    }

    zoomchanged(){
        console.log('mapZoomed: ' + JSON.stringify(this.state.map.getZoom()))
	}

    handleMarkerClick(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) {
                    return {
                        ...marker,
                        showInfo: true,
                    };
                }
                return marker;
            }),
        });
    }

    handleMarkerClose(targetMarker) {
        this.setState({
            markers: this.state.markers.map(marker => {
                if (marker === targetMarker) {
                    return {
                        ...marker,
                        showInfo: false,
                    };
                }
                return marker;
            }),
        });
	}

	renderMarkers(mapMarkers) {
		if (mapMarkers) {
			return (
				mapMarkers.map((marker, index) => (
					<Marker
						key={marker.projectId}
						position={marker.position}
					/>
				))
			)
		}
	}

	render() {
		const { mapMarkers } = this.props;
		// const markers = [
        //     {
        //         position: { lat: -34.495, lng: 150.754 },
        //         showInfo: false,
        //         infoContent: false,
        //     },
        //     {
        //         position: { lat: -34.397, lng: 150.644 },
        //         showInfo: false,
        //         infoContent: false,
        //     },
		// ]

		// const pathCoordinates = [
		// 	{lat: -34.495, lng: 150.754},
		// 	{lat: -34.397,lng: 150.644},
		// ]

    	return (
			<GoogleMap
				ref={this.mapLoaded.bind(this)}
				defaultZoom={3}
				defaultCenter={{"lat":16.989481383818443,"lng":69.67476171875}}
				onDragEnd={this.mapMoved.bind(this)}
				onZoomChanged={this.zoomchanged.bind(this)}
			>

				<MarkerClusterer
					// onClick={props.onMarkerClustererClick}
					averageCenter
					enableRetinaIcons
					gridSize={60}
				>
					{this.renderMarkers(mapMarkers)}

					{/* {markers.map((marker, index) => (
						<Marker
							key={index}
							position={marker.position}
						/>
					))} */}
				</MarkerClusterer>

				{/* {markers.map((marker, index) => (
					<Marker
						key={index}
						position={marker.position}
						title="click on it Sir..!!"
						// defaultPosition={this.props.center}
						style={{height: '2xpx', width: '2px'}}
					/>
				))} */}

				{/*for creating path with the updated coordinates*/}
				{/* <Polyline
					path={pathCoordinates}
					geodesic={true}
					options={{
						strokeColor: '#ff2527',
						strokeOpacity: 0.0,
						strokeWeight: 2,
						icons: [{
							icon: lineSymbol,
							offset: '0',
							repeat: '20px'
						}],
					}}
				/> */}

			</GoogleMap>
    	);
  	}
}

export default withScriptjs(withGoogleMap(googleMapComponent));



// WEBPACK FOOTER //
// ./src/components/Maps/MapContainer3.js